var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgActionsTrigger = function SvgActionsTrigger(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00016 1.99935C3.00016 2.73573 2.40321 3.33268 1.66683 3.33268C0.93045 3.33268 0.333496 2.73573 0.333496 1.99935C0.333496 1.26297 0.93045 0.666016 1.66683 0.666016C2.40321 0.666016 3.00016 1.26297 3.00016 1.99935Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 1.99935C8.3335 2.73573 7.73654 3.33268 7.00016 3.33268C6.26378 3.33268 5.66683 2.73573 5.66683 1.99935C5.66683 1.26297 6.26378 0.666016 7.00016 0.666016C7.73654 0.666016 8.3335 1.26297 8.3335 1.99935Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3335 3.33268C13.0699 3.33268 13.6668 2.73573 13.6668 1.99935C13.6668 1.26297 13.0699 0.666016 12.3335 0.666016C11.5971 0.666016 11.0002 1.26297 11.0002 1.99935C11.0002 2.73573 11.5971 3.33268 12.3335 3.33268Z",
    fill: "currentColor"
  })));
};
export default SvgActionsTrigger;